import {
  Button,
  Field,
  ModalV2,
  Select,
  Stack,
  Title,
  useToast
} from "@introist/react-foundation/v2";
import { useState } from "react";
import { api } from "services/rpc/RpcProvider";

type UseTemplateModalProps = {
  open: boolean;
  onClose: VoidFunction;
  templateId: string;
  templateName: string;
  onWorkflowCreated: (workflowId: string) => void;
};

export const UseTemplateModal = ({
  open,
  onClose,
  templateId,
  templateName,
  onWorkflowCreated
}: UseTemplateModalProps) => {
  const toast = useToast();
  const [selectedFolderId, setSelectedFolderId] = useState<string | undefined>(undefined);

  const { data: folders } = api.workflows.v4.folders.list.useQuery({});
  const useTemplate = api.workflows.templates.use.useMutation();

  const folderOptions = [
    ...(folders || []).map(folder => ({
      key: folder.id,
      title: folder.name,
      value: folder.id
    }))
  ];

  const handleCreate = async () => {
    try {
      const result = await useTemplate.mutateAsync({
        templateId,
        targetFolderId: selectedFolderId
      });

      toast.success("Workflow created from template");
      onWorkflowCreated(result.workflowId);
      onClose();
    } catch (error) {
      toast.error("Failed to create workflow from template");
    }
  };

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      title="Use this template"
      footer={
        <Stack justifyContent="flex-end" gap="small">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button onClickWithLoading={handleCreate}>Create</Button>
        </Stack>
      }
    >
      <Stack vertical gap="xLarge">
        <Title>
          This will create a new workflow based on the template <strong>{templateName}</strong>. All
          steps and settings will be copied to the new workflow.
        </Title>

        <Field title="Create in folder">
          <Select
            placeholder="No folder"
            options={folderOptions}
            value={selectedFolderId}
            onSelect={opt => setSelectedFolderId(opt.key)}
            style={{ width: "100%" }}
            attachToRef={false}
            searchable
          />
        </Field>
      </Stack>
    </ModalV2>
  );
};
